import { config } from "@/shared/lib/config";

export type FormExternalPublicLink = {
  systemKey: string;
  systemLabel: string;
  href: string;
  qrFilenameSuffix: string;
  hint?: string;
};

/** Locale ຫຼັກໃນ QR (ຜູ້ໃຊ້ປ່ຽນພາສາໃນ LIHF ໄດ້) */
const LIHF_DEFAULT_LOCALE = "lo";

const LIHF_FORM_REGISTER_PATH: Record<string, string> = {
  lihf_frm_competition: "/register/competition",
  lihf_frm_vendor: "/register/vendor",
  lihf_frm_sponsor: "/register/sponsor",
  lihf_frm_visitor: "/register/visitor",
};

function lihfRegisterHref(formId: string): string | null {
  const pathSuffix = LIHF_FORM_REGISTER_PATH[formId];
  const base = config.lihfPublicUrl;
  if (!pathSuffix || !base) return null;
  return `${base}/${LIHF_DEFAULT_LOCALE}${pathSuffix}`;
}

/**
 * Public URLs on client sites that submit to this form via Fanglao Public API.
 * Add mappings here when a new integrated site goes live.
 */
export function getFormExternalPublicLinks(
  formId: string,
): FormExternalPublicLink[] {
  const links: FormExternalPublicLink[] = [];

  const lihfHref = lihfRegisterHref(formId);
  if (lihfHref) {
    links.push({
      systemKey: "lihf",
      systemLabel: "LIHF Website",
      href: lihfHref,
      qrFilenameSuffix: "lihf",
      hint: "ຟອມນີ້ເຊື່ອມ LIHF · QR ເປີດ /lo/… (ມີ lo/th/en/zh)",
    });
  }

  return links;
}
